<template>
  <figure
      class="mc-card-poker "
      :class="{
        'mc-card-poker--show-border': hover === 'showBorder',
        'mc-card-poker--card-event' : !btnText && clickTarget !== 'customBtn',
        'is-disabled': disabled
      }"
      @click="_onClick('card')"
  >
    <img
        class="mc-card-poker__img"
        :class="{
          'is-round' : isImgRound
        }"
        :src="imgUrl"/>
    <h4 class="mc-card-poker__title">
      {{title}}
    </h4>
    <time
        class="mc-card-poker__date"
        :datetime="time"
        v-if="!!time" >{{time}}</time>
    <p
        class="mc-card-poker__description"
        v-if="text">{{text}}</p>
    <footer v-if="btnText !== ''">
      <mc-btn size="small" @click="onClick('customBtn')">{{btnText}}</mc-btn>
    </footer>
  </figure>
</template>
<script type="text/ecmascript-6">
  import mcBtn from './base-btn';
  export default {
    name: 'mcCardPoker',
    components: {mcBtn},
    props: {
      hover: {
        type: String,
        default: 'showBorder'   // showBorder 主色边框    showMask  模板&操作按钮
      },
      clickTarget: {
        type: String,
        default: 'card'   // showBorder 主色边框    showMask  模板&操作按钮
      },
      btnText: {
        type: String,
        default: ''
      },
      isImgRound: {
        type: Boolean,
        default: false
      },
      imgUrl: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      time: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }

    },
    computed: {
        computedTarget(){
            if(this.btnText === ''){
                return 'card'
            }else{
                return 'customBtn'
            }
        }
    },
    methods:{
      _onClick(type){
        if ( !this.disabled && type === 'card' && this.computedTarget === 'card' ) {
          this.$emit('click',type);
        } else if( type === 'customBtn' && this.computedTarget === 'customBtn'){
          this.$emit('click',type);
        }

      }
    }


  }
</script>



// WEBPACK FOOTER //
// src/components/card-poker.vue